import { cwdDir, getBuildinfoTsup } from "@/share"
import { IAnyBuildConfigByTsup } from "@/share/type"
import { error } from "@/util"
import { loadConfigFromFile } from "@noderun/loadconfig"
import fs from "fs-extra"
import path from "path"

export let tsupModule: typeof import("tsup")

export async function loadModule() {
    try {
        tsupModule = await import("tsup")
    } catch (err) {
        error(`未安装包：tsup`, "exit")
    }
    await getAnybuildConfigAsync()
}

export const holder: {
    userConfig: {
        path: string
        config: IAnyBuildConfigByTsup
        dependencies: string[]
    }
} = {
    userConfig: undefined
}

export function getAnybuildConfig() {
    if (holder.userConfig) return holder.userConfig
}

export async function getAnybuildConfigAsync() {
    let _config = getBuildinfoTsup()
    const isDev = !!_config.watch
    if (fs.pathExistsSync(path.resolve(cwdDir, "anybuild.config.ts"))) {
        holder.userConfig = await loadConfigFromFile(
            {
                mode: isDev ? "development" : "production",
                command: isDev ? 'serve' : 'build'
            },
            "anybuild.config.ts",
            cwdDir
        ) as any
    }
    return holder.userConfig
}